import { L as Logo, d as defineCustomElement$1 } from './logo.js';
var SkpLogo = Logo;
var defineCustomElement = defineCustomElement$1;
export { SkpLogo, defineCustomElement };